import { createQueryKeys } from '@lukemorales/query-key-factory';

import { usersService } from '@ll-platform/frontend/core/users/async/UsersService';
import { createQueryHook } from '@ll-platform/frontend/utils/factories/createQueryHook';
import { createQueryOption } from '@ll-platform/frontend/utils/factories/createQueryOption';

export const UsersQueries = createQueryKeys('users', {
  list: createQueryOption(usersService.list.bind(usersService)),
  getById: createQueryOption(usersService.getById.bind(usersService)),
});

export const useGetUserById = createQueryHook(UsersQueries.getById);

export const useListUsers = createQueryHook(UsersQueries.list);
